import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import CircularProgress from '@mui/material/CircularProgress';
import { Text } from '@eo-locale/react';
import { styled } from '@mui/material/styles';
import { classes } from '@guest-widgets/shared/src/classes';

import { useProducts } from '../productsContext';

const Pagination = () => {
  const { products, loadProducts, hasMorePages, totalCount, pageSize, isLoading } = useProducts();

  if (!products || !totalCount || totalCount <= pageSize) return null;

  return (
    <Container>
      <Typography className={classes.catalog.pagination.statusbar} variant="caption">
        <Text
          id="product-catalog.pagination.progress"
          loaded={products.length}
          total={totalCount}
        />
      </Typography>
      <Progress
        variant="determinate"
        aria-describedby="loading progress"
        value={(products.length * 100) / totalCount}
        color="secondary"
      />
      {hasMorePages && (
        <Button
          className={classes.catalog.pagination.button}
          variant="outlined"
          color="primary"
          sx={{ zIndex: 10 }}
          onClick={loadProducts}
        >
          <Text id="product-catalog.pagination.load-more" />
          {isLoading && (
            <LoadingContainer>
              <CircularProgress size={20} />
            </LoadingContainer>
          )}
        </Button>
      )}
    </Container>
  );
};

const Container = styled('div')(({ theme }) => ({
  maxWidth: 295,
  margin: 'auto',
  textAlign: 'center',
  marginTop: theme.spacing(8),
}));

const Progress = styled(LinearProgress)(({ theme: { spacing } }) => ({
  marginBottom: spacing(4),
  borderRadius: spacing(0.5),
}));

export const LoadingContainer = styled(Box)(({ theme: { palette } }) => ({
  position: 'absolute',
  top: -2,
  left: -2,
  width: 'calc(100% + 4px)',
  height: 'calc(100% + 4px)',
  background: palette.common.white,
  opacity: 0.6,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export default Pagination;
